import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  FormButtonStyledLeftIcon,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../../../../components/styled/Elements";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { formateAmounts } from "../../../../../utils";
import ValidatedInput from "../../../../../components/common/inputFields/ValidatedInput";
import CustomRadioButton from "../../../../../components/common/radioButtons/CustomRadio";
import ValidationErrorText from "../../../../../components/common/inputFields/ValidationErrorText";
import {
  Download,
  LeftArrowBlack,
  RightArrowWhite,
  RightArrowWithoutBar,
} from "../../../../../components/styled/AllImages";
import { useUser } from "../../../../../context/userContext";
import BillingAPI from "../../../../../services/api/billingApi";
import { toast } from "react-toastify";

const LicenseStep1 = ({
  planInfo,
  handleSteps,
  paymentMethod,
  bankInfo,
  totalAmount,
  setTotalAmount,
  setPaymentMethod,
  setValue,
  addLicenseFrm,
  register,
  watch,
  errors,
  action,
  onHide
}) => {
  const numOfLicenses = watch("number_of_licenses") || 0;
  const { t } = useTranslation();
  const { user, fetchUserInfo } = useUser();
  const savedCard = user?.card_details;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const payment_method = searchParams.get("payment_method");
  const selectedCardOption = watch("use_saved_card") || 0;
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPaymentMethod(value);
    setValue(name, value);
  };

  useEffect(() => {

    if (planInfo?.amount) {
      const baseCost = parseFloat(planInfo?.amount);
      const vatAmount = bankInfo?.vat?.vat
        ? (parseFloat(bankInfo?.vat?.vat) / 100) * baseCost
        : 0;
      const totalAmount =
        parseFloat(baseCost.toFixed(2)) + parseFloat(vatAmount.toFixed(2));

      setTotalAmount(totalAmount);
      // setTotalAmount(totalAmount.toFixed(2));
    }
  }, [planInfo]);

  const signUpStepTwo = async () => {
    console.log('signup flow called');
    setSubmitLoading(true);
    const baseCost = parseFloat(planInfo?.amount);
    const baseObj = {
      plan_id: planInfo?.id,
      plan_duration: planInfo?.duration || 1,
      total_amount: totalAmount,
      use_saved_card: selectedCardOption,
      // number_of_licenses: numOfLicenses,
      token_id: null,
      action: action,
      sub_total: baseCost,
      ...(bankInfo?.vat?.vat && {
        vat_percentage: bankInfo?.vat?.vat,
        vat_value: (parseFloat(bankInfo?.vat?.vat) / 100) * baseCost,
      }),
    };

    const formData = new FormData();
    Object.entries(baseObj).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const { code, message, data } = await BillingAPI.upgradeOrgPlan(formData);
      if (code === 200) {
        window.open(data?.payment_url, "_self");
        onHide();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Step1Wrapper>
      <Box>
        {/* <Box>
          <ValidatedInput
            name="number_of_licenses"
            label={"num_of_licenses"}
            type="input"
            fieldType="number"
            placeholder={"numOfLicensePlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box> */}

        <Box className="total-wrapper">
          <Box className="total-content-wrapper">
            <TextStyled
              size="20px"
              color="var(--themeColor)"
              className="align-items-sm-baseline"
              weight="700"
            >
              {t("total")}: {totalAmount}{" "}
              {user?.organization?.currency?.stringCode || t("sar")}
              <SpanStyled size="15px">
                &nbsp; &nbsp;
                {t("inc_tax")}
              </SpanStyled>
            </TextStyled>
            {/* <FormButtonStyledLeftIcon
              height={"30px"}
              size={"14px"}
              icon={Download}
              label={t("download_invoice")}
              color="var(--white)"
              bg="var(--themeColor2)"
              className="w-100 mb-3 py-2"
              clName=""
              type="button"
              // isLoading={loading}
            /> */}
          </Box>
        </Box>
        <Box className="mt-3">
          {savedCard && (
            <CardOption
              className={`mb-2 ${
                parseInt(selectedCardOption) === 1 ? "active" : ""
              }`}
              onClick={() => setValue("use_saved_card", 1)}
            >
              <input
                type="radio"
                name="card_option"
                value={1}
                checked={parseInt(selectedCardOption) === 1}
                onChange={() => setValue("use_saved_card", 1)}
              />
              <CardDetails>
                <span className="brand">{savedCard?.brand}</span>
                <span className="digits">•••• {savedCard?.last_four}</span>
                <span className="expiry">
                  {t("exp")}: {savedCard?.exp_month}/{savedCard?.exp_year}
                </span>
              </CardDetails>
            </CardOption>
          )}
          <CardOption
            className={!selectedCardOption ? "active" : ""}
            onClick={() => setValue("use_saved_card", 0)}
          >
            <input
              type="radio"
              name="card_option"
              value="new_card"
              checked={!selectedCardOption}
              onChange={() => setValue("use_saved_card", 0)}
            />
            <CardDetails>
              <span>{t("pay_with_new_card")}</span>
            </CardDetails>
          </CardOption>
        </Box>
      </Box>
      <Box className="d-flex justify-content-end align-items-center gap-3 my-3">
        <ButtonStyled
          border="var(--borderExtraLight)"
          iconBefore={LeftArrowBlack}
          bg="transparent"
          label={t("Cancel")}
          color="var(--text)"
          type="button"
        />
        <ButtonStyled
          bg="var(--themeColor)"
          label={t("next")}
          type="button"
          onClick={(e) => parseInt(selectedCardOption) === 1 ? signUpStepTwo() : handleSteps(e)}
          icon={RightArrowWhite}
          isLoading={submitLoading}
          disabled={submitLoading}
        />
      </Box>
    </Step1Wrapper>
  );
};

export default LicenseStep1;

const Step1Wrapper = styled.div`
  .total-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-block: 20px;
  }
  .total-content-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    @media (max-width: 900px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
    @media (max-width: 395px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

const CardOption = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 2px solid var(--borderColor, #ddd);
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: 0.3s ease;
  background: var(--white);

  &.active {
    border-color: var(--themeColor);
    background: #f9faff;
  }

  input {
    accent-color: var(--themeColor);
    cursor: pointer;
  }
`;

const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: var(--text);

  .brand {
    font-weight: 600;
  }
  .digits {
    font-size: 15px;
    letter-spacing: 2px;
  }
  .expiry {
    font-size: 12px;
    color: #888;
  }
`;